// pages/users/ActivityLogsPage.jsx
import { useState, useEffect } from 'react';
import { RefreshCw } from 'lucide-react';
import { userController } from '../../controllers/userController.js';
import { C } from '../../hooks/useUsers.js';
import { Pagination } from '../../components/users/UserTable.jsx';

const ACTION_COLORS = {
  'Login': '#10b981', 'Logout': '#94a3b8', 'Profile Updated': '#3b82f6',
  'Password Changed': '#f59e0b', 'Wallet Credited': '#8b5cf6',
  'Order Placed': '#059669', 'Permission Changed': '#dc2626', 'Status Changed': '#d97706',
};

export function ActivityLogsPage() {
  const [logs, setLogs]         = useState([]);
  const [loading, setLoading]   = useState(true);
  const [page, setPage]         = useState(1);
  const [total, setTotal]       = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch]     = useState('');

  const fetch = async () => {
    setLoading(true);
    const res = await userController.getActivityLogs({ page, limit: 20 });
    if (res.success) { setLogs(res.data); setTotal(res.total); setTotalPages(res.totalPages); }
    setLoading(false);
  };

  useEffect(() => { fetch(); }, [page]);

  const filtered = search
    ? logs.filter(l => l.userName.toLowerCase().includes(search.toLowerCase()) || l.action.toLowerCase().includes(search.toLowerCase()))
    : logs;

  return (
    <div style={C.page}>
      <div style={C.header}>
        <h1 style={{ ...C.title, borderLeft: '4px solid #0891b2', paddingLeft: '12px' }}>User Activity Logs</h1>
        <button style={{ ...C.btn, ...C.btnSec }} onClick={fetch}><RefreshCw size={15} /> Refresh</button>
      </div>

      <div style={C.filterBar}>
        <div style={C.searchWrap}>
          <span style={{ ...C.searchIco, fontSize: '16px' }}>⌕</span>
          <input style={C.searchIn} placeholder="Search user or action…" value={search} onChange={e => setSearch(e.target.value)} />
        </div>
      </div>

      <div style={C.card}>
        {loading ? (
          <div style={{ padding: '60px', textAlign: 'center', color: '#94a3b8' }}>
            <RefreshCw size={28} style={{ animation: 'spin 1s linear infinite' }} />
            <div style={{ marginTop: '12px' }}>Loading logs…</div>
          </div>
        ) : (
          <>
            <table style={C.table}>
              <thead>
                <tr>
                  <th style={C.th}>User</th>
                  <th style={C.th}>Action</th>
                  <th style={C.th}>Device</th>
                  <th style={C.th}>IP Address</th>
                  <th style={C.th}>Time</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(log => (
                  <tr key={log.id}>
                    <td style={C.td}>
                      <div style={{ fontSize: '13px', fontWeight: '600' }}>{log.userName}</div>
                      <div style={{ fontSize: '11px', color: '#94a3b8', textTransform: 'capitalize' }}>{log.userRole?.replace(/_/g,' ')}</div>
                    </td>
                    <td style={C.td}>
                      <span style={{ ...C.badge, backgroundColor: `${ACTION_COLORS[log.action] || '#64748b'}15`, color: ACTION_COLORS[log.action] || '#64748b' }}>
                        {log.action}
                      </span>
                    </td>
                    <td style={C.td}><span style={{ fontSize: '12px' }}>{log.device}</span></td>
                    <td style={C.td}><span style={{ fontSize: '12px', fontFamily: 'monospace', color: '#64748b' }}>{log.ip}</span></td>
                    <td style={C.td}><span style={{ fontSize: '12px', color: '#94a3b8' }}>{new Date(log.createdAt).toLocaleString('en-IN')}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Pagination page={page} totalPages={totalPages} total={total} limit={20} onPage={setPage} />
          </>
        )}
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
export default ActivityLogsPage;


